export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Chat.3145c729.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};